export const SummitSection = ({ summit }) => {
  const [primary, secondary] = summit.buttons;
  const rel = (url) => (/^https?:/.test(url) ? "noopener" : undefined);
  return (
    <section className="section dark net-pattern" id="summit" aria-labelledby="summit-title" data-testid="summit-section">
      <div className="wrap">
        <div className="summit-head">
          <div>
            <p className="when">{summit.date_line}</p>
            <h2 id="summit-title">{summit.title}</h2>
            <p className="summit-theme">{summit.theme}</p>
          </div>
          <div>
            {summit.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>

        <ol className="route">
          {summit.stops.map((s, i) => (
            <li key={i}>
              <span className="dates">{s.dates}</span>
              <span className="place">{s.place}</span>
              <p>{s.text}</p>
            </li>
          ))}
        </ol>

        <div className="actions">
          <a className="btn gold" href={primary.url} rel={rel(primary.url)} data-testid="summit-primary-button">{primary.label}</a>
          <a className="btn on-dark" href={secondary.url} rel={rel(secondary.url)} data-testid="summit-secondary-button">{secondary.label}</a>
        </div>
        <p className="small" style={{ marginTop: "1.25rem" }}>{summit.note}</p>
      </div>
    </section>
  );
};
